<template>
  <div class="report-details">
    <van-cell-group>
      <div class="header">
        <h2>{{ reportData.goodName }}</h2>
      </div>
      <div class="info-grid">
        <div class="info-item">
          <span class="info-title">IMEI/SN</span>
          <span class="info-content">{{ reportData.sn }}</span>
        </div>
        <div class="info-item">
          <span class="info-title">检测时间</span>
          <span class="info-content">{{ reportData.checkDate }}</span>
        </div>
      </div>
    </van-cell-group>

    <van-collapse v-model="activeNames">
      <van-collapse-item title="外观成色" name="1" style="text-align: left">
        <span style="font-weight: bold">{{ reportData.generalInfo }}</span>
      </van-collapse-item>
      <van-collapse-item
        v-for="(group, index) in reportData.groupList"
        :key="index"
        :name="index"
      >
        <template #title>
          <div class="collapse-title">
            <span>{{ group.type }}</span>
            <span>
              <van-icon name="passed" color="#1CC976" />
              {{ group.propertyList.length }}项
            </span>
          </div>
        </template>
        <div class="property-list">
          <div
            v-for="property in group.propertyList"
            :key="property.id"
            class="property-item"
          >
            <span class="property-name">{{ property.name }}</span>
            <span class="result-hr"></span>
            <span class="property-value">{{ property.propertyValue }}</span>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <p class="note">
      商品检测拆修情况目前仅针对部件有第三方拆修情况进行检测，对于厂家官方的维修因技术原因无法进行判断。平台仅对设备本身在标准的质检环境下的功能进行客观检测，配件不在检测范围。
    </p>
    <watermark/>
  </div>
</template>

<script>
import watermark from './watermark.vue'
export default {
  data () {
    return {
      activeNames: ['1'],
      reportData: {}
    }
  },
  components: {
    watermark
  },
  mounted () {
    //  document.title = '质检报告'
    let id = this.$route.query.reportNo
    this.get(id.toString())
  },
  methods: {
    get (reportNo) {
      this.axios({
        method: 'post',
        url: 'api/report/getReport',
        data: {
          reportNo: reportNo
        }
      }).then(res => {
        if (res.data.code == 200) {
          this.reportData = res.data.data
        }
      })
    },

  }
}
</script>

<style>
.device-details {
  padding: 16px;
}

.header h2 {
  font-weight: bold;
  padding: 16px;
  font-size: 20px;
  text-align: left;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.info-title {
  font-weight: bold;
  margin-bottom: 4px;
  color: #ccc;
  font-size: 12px;
}

.info-content {
  color: #000;
  font-weight: 700;
  font-size: 14px;
}
.collapse-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 15px;
}
.property-list {
  display: flex;
  flex-direction: column;
}

.property-item {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 8px 0;
}
.result-hr {
  border-top: 1px dashed #99999f;
  margin: 0 10px;
  flex: 1;
}
.property-name {
  font-weight: bold;
}

.property-value {
  font-size: 14px;
  color: #1ad37a;
  font-weight: 700;
}
.van-cell__title {
  font-size: 15px;
}
.note {
  margin-top: 16px;
  color: #888;
  padding: 16px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/report.vue